import { render, staticRenderFns } from "./SectionOfQuestionsImpact.vue?vue&type=template&id=7601b4e2&"
import script from "./SectionOfQuestionsImpact.vue?vue&type=script&lang=js&"
export * from "./SectionOfQuestionsImpact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports